import React, {ReactElement} from "react";
import {getActivities} from "../../services/ServiceActivity";
import {Button, Col, Collapse, List, Row, Space} from "antd";
import IInstance from "../../interfaces/IInstance";
import {Custom} from "../../utils/refineUtils";
// @ts-ignore
import {v4 as uuidv4} from "uuid";
import {Link, useLocation} from "react-router-dom";
import {getAuthentications} from "../../services/ServiceAuthentication";
import {getClients} from "../../services/ServiceClient";
import {getTypes} from "../../services/ServiceType";
import {EditOutlined, UserOutlined} from "@ant-design/icons";
import * as dayjs from "dayjs";
import {useCreate} from "@refinedev/core";
import IType from "../../interfaces/IType";

export default function DeepLink(): ReactElement | null {

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    const query = useQuery();
    const ltik = query.get("ltik") ?? '';

    // Variables

    const {activities} = getActivities()
    const {authentications} = getAuthentications()
    const {clients} = getClients();
    const {types} = getTypes();


    const IconText = ({ icon, text }: { icon: ReactElement; text: string }) => (
        <Space>
            <>
                {icon}
                {text}
            </>
        </Space>
    );

    const {mutate} = useCreate()
    const selectInstance = (activityId: string, instanceId: string) => {
        mutate({
            resource: window.userprofile.path.deeplink,
            values: {ltik: ltik, activityId: activityId, instanceId: instanceId}
        }, {onSuccess: (data: any) => document.write(data.data.form)})
    }

    // Functions

    return (
        <>
            {activities?.map((activity, index) => (
                <Collapse key={index} style={{marginBottom: 16}}
                    items={[{label: activity?.title, children:
                        <>
                            <Space direction="vertical" style={{width: "100%"}}>
                                <Row align="middle">
                                    <Col span={7}>
                                        <Custom.Info title="Clients" value={
                                            <span style={{overflow: 'hidden', display: "flex", flexDirection: "row", textOverflow: "ellipsis", whiteSpace:"nowrap"}}>
                                                {activity?.clients?.map((client, index: number) => {
                                                    const cli = clients?.find(cl => cl.id === client.id);
                                                    return cli && <Custom.ClientInfo key={index} client={cli}/>
                                                })}
                                                {activity?.clients?.length === 0 &&
                                                    <span>Aucun clients</span>
                                                }
                                            </span>
                                        }/>
                                    </Col>
                                    <Col>
                                        <Custom.Info title="Authentifications" value={
                                            <span style={{overflow: 'hidden', display: "flex", flexDirection: "row", textOverflow: "ellipsis", whiteSpace:"nowrap"}}>
                                                {activity?.authentications?.map((authentication, index: number) => {
                                                    const auth = authentications?.find(auth => auth.id === authentication);
                                                    return auth && <Custom.AuthInfo auth={auth} type={types?.find(type => type.id === auth.type) as IType} key={index}/>

                                                })}
                                                {activity?.authentications?.length === 0 &&
                                                    <span>Aucune authentifications</span>
                                                }
                                            </span>
                                        }/>
                                    </Col>
                                </Row>
                                <Custom.Title style={{marginTop: 16}} title="Liste des instances" icon="ant-design:calendar-outlined"/>
                                <List
                                    size="small"
                                    itemLayout="vertical"
                                    dataSource={activity?.instances}
                                    renderItem={(item: IInstance) => (
                                        <List.Item
                                            key={uuidv4()}
                                            actions={[
                                                <IconText icon={<UserOutlined/>} text={item?.users?.length.toString() ?? "0"}/>,
                                                <IconText icon={<EditOutlined/>} text={item?.tutor ?? "Aucun encadrant"}/>,
                                                <Button onClick={() => selectInstance(activity?.id, item?.id)} size="small">Choisir</Button>
                                            ]}
                                        >
                                            <List.Item.Meta
                                                title={item?.title}
                                                description={"Du " + dayjs(item?.start).format("DD/MM/YYYY HH:mm:ss") + " au " + dayjs(item?.end).format("DD/MM/YYYY HH:mm:ss.")}
                                            />
                                        </List.Item>
                                    )}
                                />
                            </Space>
                        </>
                    }]}
                />
            ))}
        </>
    )
}